export default {
  name: 'B4'
}
